<div [hidden]="!visible">
  <p-treetable #pTable class="rt-scroll-tt" [class.table-large]="tableLarge()" [columns]="selectColumns()"
    [class.mobile-table]="navigationService.isMobileOrTablet()" [hidden]="!filtering.value" [value]="treeNodes"
    [rows]="20" [paginator]="!hidePaginator" [first]="first || 0" [resetPageOnSort]="true"
    [selectionMode]="selectionMode()!" [(selection)]="selectedNode" dataKey="id" (onNodeSelect)="nodeSelect($event)"
    [customSort]="true" (sortFunction)="defaultSort($event)" [style]="{ 'font-size': small ? '0.8em' : '1em' }"  (contextMenuSelectionChange)="onRightClick($event)" [contextMenu]="cm">

    <!-- ===== CAPTION ===== -->
    <ng-template pTemplate="caption">

      <div class="d-flex flex-column gap-3 ">
        <div #containerActions class="d-flex flex-row align-content-end flex-wrap gap-4 w-100 p-0 badge"
          [class.justify-content-between]="navigationService.isMobileOrTablet()"
          [class.justify-content-end]="!navigationService.isMobileOrTablet()"
          [class.order-1]="navigationService.isMobile()">
          <button *ngIf="enableFilter" class="btn btn-sm btn-outline-dark fw-bold" (click)="filterPressed.emit()">
            <i class="fa fa-filter" style="margin:4px 4px 0 0"></i>
            Filtros
          </button>

          <ng-template *ngIf="header" ngFor let-col [ngForOf]="[cols]" let-i="index" [ngForTemplate]="header">
          </ng-template>
        </div>

        <div class="d-flex flex-row flex-nowrap w-100 gap-2 p-0 badge"
          [class.w-100]="navigationService.isMobileOrTablet()">
          <ng-template *ngIf="center" ngFor let-col [ngForOf]="[cols]" [ngForTemplate]="center">
          </ng-template>
        </div>

        <div class="w-100 d-flex justify-content-between align-items-center mb-2"
          [class.gap-3]="navigationService.isMobile()" [class.gap-5]="!navigationService.isMobile()"
          [class.flex-wrap]="navigationService.isMobile()">
          <div #searchContainer class="p-0 d-flex" [class.w-100]="navigationService.isMobile()"
            [class.w-75]="!navigationService.isMobile()">
            <p-iconfield class="w-100">
              <p-inputicon *ngIf="request.isLoading" styleClass="pi pi-spin pi-spinner" />

              <p-inputicon *ngIf="!request.isLoading" styleClass="pi pi-search" />
              <input #searchText [(ngModel)]="searchValue.term" pInputText
                (input)="setGlobalContentFilter($event.target)" type="text" placeholder="Buscar..."
                (keyup)="setSearchText(searchText.value)">
            </p-iconfield>
          </div>

          @if (actionButtonText && ['tomega', 'detorres'].includes(this.appName) ||
          !['gerencia','aplicador'].includes(this.rol)) {
          <div class="d-flex align-items-center justify-content-between text-left gap-3"
            [class.w-100]="navigationService.isMobile()">
            <span *ngIf="request.hasError" style="margin-right:10px" tooltipPosition="bottom"
              pTooltip="Ha ocurrido un error...">
              <i class="fa fa-exclamation-triangle" style="color:black"></i>
            </span>

            <button pButton *ngIf="showExportCsv && !customExportCsv"
              class="border-0 text-white text-nowrap fw-bold align-self-end" (click)="exportCsv()"
              style="background-color:#27A745;">
              <i class="fa fa-download"></i>
              Exportar a CSV

            </button>

            @if(showAddButton()) {

            <button *ngIf="actionButtonText !== ''" pButton icon="pi pi-plus" (click)="actionButtonClick.emit()"
              class="text-nowrap" style="font-weight: bold;background-color:#2196f3;  border: none !important;">

              {{actionButtonText}}
            </button>
            }
          </div>
          }
        </div>
      </div>
    </ng-template>

    <!-- ===== COLGROUP ===== -->
    <ng-template pTemplate="colgroup" let-columns>
      <colgroup>
        <col *ngFor="let col of cols" [style.width]="5">
      </colgroup>
    </ng-template>

    <!-- ===== HEADER ===== -->
    <ng-template pTemplate="header">
      <tr class="small">
        <th *ngIf="selectionMode() === 'checkbox'">
          <p-treeTableHeaderCheckbox></p-treeTableHeaderCheckbox>
        </th>

        <ng-template *ngIf="thStart" ngFor let-col [ngForOf]="[cols]" [ngForTemplate]="thStart">
        </ng-template>

        <th *ngFor="let col of cols" [ttSortableColumn]="col.field" class="rt-clamp">
          <div class="d-flex justify-content-center align-items-center" *ngIf="!col.filter">
            {{col.header}}
            <p-treeTableSortIcon *ngIf="col.sort !== false" [field]="col.field" class="ms-2" />
          </div>

          <div *ngIf="col.filter">
            {{col.header}}
            <div [ngSwitch]="col.filter">
              <p-select *ngSwitchCase="'dropdown'" [options]="dropdown[col.field]"
                [style]="{'width':'100%','fontSize':'0.7em'}" (onChange)="setDropdownSelectOn($event.value,col.field)">
              </p-select>

              <p-multiSelect *ngSwitchCase="'multiselect'" [options]="multiselect[col.field]"
                [(ngModel)]="filters.multiselect[col.field]" [style]="{'width':'100%','fontSize':'0.7em'}"
                (onChange)="setMultiSelectOn($event.value,col.field)">
              </p-multiSelect>

              <p-datePicker *ngSwitchCase="'calendar'" [(ngModel)]="filters.dateRange[col.field]"
                (onClose)="setDateRangeOn()" (onClearClick)="cleanDateRangeOn(col.field)" [monthNavigator]="true"
                [yearNavigator]="true" yearRange="2005:2030" showButtonBar="true" selectionMode()="range"
                readonlyInput="true">
              </p-datePicker>
            </div>
          </div>
        </th>

        <!-- Columna de Acciones -->
        <th *ngIf="hasEditableFields && editButtonsPosition === 'tableEnd'" class="rt-actions">
          <div class="d-flex justify-content-center align-items-center min-height-40">
            <span>Acciones</span>
          </div>
        </th>

        <ng-template *ngIf="thEnd" ngFor let-col [ngForOf]="[cols]" [ngForTemplate]="thEnd">
        </ng-template>
      </tr>
    </ng-template>

    <!-- ===== BODY ===== -->
    <ng-template pTemplate="body" let-data>
      <tr class="base-row-style" [ttRow]="data" [ttSelectableRow]="data"
        [ngStyle]="processRowConditionalStyle(data.node)" [ttContextMenuRow]="data">

        <td *ngIf="selectionMode() === 'checkbox'">
          <p-treeTableCheckbox [value]="data"></p-treeTableCheckbox>
        </td>

        <ng-template *ngIf="tdStart" ngFor let-data [ngForOf]="[data.node]" [ngForTemplate]="tdStart">
        </ng-template>

        <!-- Celdas dinámicas -->
        <td *ngFor="let col of cols" class="ui-resizable-column" [attr.data-label]="col.header"
          [ngStyle]="processCellConditionalStyle(data.node,col)" ttEditableColumn>

          <div *ngIf="col.editable" class="edit-field">
            <p-treeTableCellEditor>
              <ng-template pTemplate="input">
                <p-datePicker class="input-edit-field" [(ngModel)]="data.node.data[col.field]" hourFormat="24"
                  dateFormat="hh:mm" dataType="string" [timeOnly]="true" placeholder="..."
                  [ngModelOptions]="{updateOn:'blur'}" (onBlur)="editField($event,data.node,col.field)">
                </p-datePicker>
              </ng-template>
              <ng-template pTemplate="output">
                {{processCellVisualTransform(data.node,col)}}
              </ng-template>
            </p-treeTableCellEditor>
          </div>

          <div *ngIf="!col.editable" class="rt-cell" [attr.title]="getFullCellValue(data.node, col)">
            {{processCellVisualTransform(data.node,col)}}
          </div>
        </td>

        <!-- Columna Acciones -->
        <td *ngIf="hasEditableFields && editButtonsPosition === 'tableEnd'" class="rt-actions"
          [attr.data-label]="'Acciones'">
          <div class="rt-actions-wrap">
            <button class="rt-icon rt-save" (click)="saveButtonClick.emit()">
              <i class="fa fa-save"></i>
            </button>
            <button class="rt-icon rt-undo" (click)="undoButtonClick.emit()">
              <i class="fa fa-undo"></i>
            </button>
          </div>
        </td>

        <ng-template *ngIf="tdEnd" ngFor let-data [ngForOf]="[data.node]" [ngForTemplate]="tdEnd">
        </ng-template>
      </tr>
    </ng-template>

    <!-- ===== FOOTER ===== -->
    <ng-template pTemplate="footer" *ngIf="footer">
      <tr class="base-row-style">
        <td *ngIf="selectionMode()  === 'checkbox'" style="font-size:0em">

        </td>
        <td *ngIf="thStart" style="font-size:0em">
          <ng-template *ngIf="thStart" ngFor let-col [ngForOf]="[cols]" [ngForTemplate]="thStart">
          </ng-template>
        </td>

        <td *ngFor="let col of cols">
          <ng-template *ngIf="footer" ngFor let-col [ngForOf]="[col]" [ngForTemplate]="footer">
          </ng-template>
        </td>

        <td *ngIf="thEnd" style="font-size:0em">
          <ng-template *ngIf="thEnd" ngFor let-col [ngForOf]="[cols]" [ngForTemplate]="thEnd">
          </ng-template>
        </td>
      </tr>
    </ng-template>
  </p-treetable>
  
  <p-contextMenu #cm [model]="menuItems"></p-contextMenu>

</div>

<a href="#" id="csvLink" style="visibility:hidden;position:fixed;"></a>